export const totalQuantity = (quantity, assignment) => {
    if (assignment.kind === "specific") {
        return assignment.allocations.reduce((sum, a) => sum + a.quantity, 0);
    }
    return quantity;
};
// How much of a 'specific' row one participant is allocated (issue #203's per-pill "×N"
// badge). `undefined` for 'everyone'/'shared' rows or a participant with no allocation —
// callers show a badge only when this is a number greater than 1.
export const allocationQuantityFor = (assignment, participantId) => assignment.kind === "specific"
    ? assignment.allocations.find((a) => a.participantId === participantId)?.quantity
    : undefined;
//# sourceMappingURL=assignment.js.map